import React from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

const ValidationErrorItem = ({ message }) => (
  <li>
    <Typography color="error.dark" variant="regular14">
      {message}
    </Typography>
  </li>
);

ValidationErrorItem.propTypes = {
  message: PropTypes.string.isRequired,
};

export default ValidationErrorItem;
